var createFind=require("./_createFind"),findIndex=require("./findIndex"),find=createFind(findIndex);module.exports=find;